module.exports = __webpack_public_path__ + "static/img/p5.ccbf9b75.png";